import { Image, Placeholder, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import PropTypes from 'prop-types';

const ContentBlock = ({ rendering, fields }) => {
  return (
    <div className="vds-content-block" data-testid={fields.testid?.value}>
      <div className="vds-content-block__inner">
        <header className="vds-content-block__header">
          {fields.icon?.value && (
            <i
              className={`fa-solid fa-${fields.icon.value}`}
              data-testid={`${fields.testid?.value}-icon`}
            />
          )}
          <Image field={fields.header} data-testid={`${fields.testid?.value}-header`} />
          <Text
            tag="h2"
            className="vds-content-block__secondary-title"
            field={fields.title}
            data-testid={`${fields.testid?.value}-title`}
          />
        </header>
        <RichText
          tag="div"
          className="vds-content-block__intro"
          field={fields.intro}
          data-testid={`${fields.testid?.value}-intro`}
        />
        <div className="vds-content-block__main  vds-content-block__main--limited-width">
          <Placeholder name="mainBlock-placeholders" rendering={rendering} />
        </div>
        {rendering?.placeholders?.['footerBlock-placeholders'] && (
          <footer className="vds-content-block__footer">
            <Placeholder name="footerBlock-placeholders" rendering={rendering} />
          </footer>
        )}
      </div>
    </div>
  );
};

ContentBlock.propTypes = {
  rendering: PropTypes.shape({
    placeholders: PropTypes.object,
  }),
  fields: PropTypes.shape({
    testid: PropTypes.shape({
      value: PropTypes.string,
    }),
    icon: PropTypes.shape({
      value: PropTypes.string,
    }),
    header: PropTypes.shape({
      value: PropTypes.shape({
        src: PropTypes.string,
      }),
    }),
    title: PropTypes.shape({
      value: PropTypes.string,
    }),
    intro: PropTypes.shape({
      value: PropTypes.string,
    }),
  }).isRequired,
};

export default ContentBlock;
